import Icon from '../components/Icon.vue'

Icon.register({
  crown: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M528 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416zM592 128c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.6 0-5.2-0.4-7.7-0.8l-72.3 192.8h-384l-72.3-192.8c-2.5 0.4-5.1 0.8-7.7 0.8-26.5 0-48-21.5-48-48s21.6-48 48.1-48 48 21.5 48 48c0 7.1-1.7 13.8-4.4 19.8l72.3 43.4c15.3 9.2 35.3 4 44.2-11.6l81.5-142.6c-10.7-8.8-17.7-22-17.7-37 0-26.5 21.5-48 48-48s48 21.5 48 48c0 15-7 28.2-17.7 37l81.5 142.6c8.9 15.6 28.8 20.8 44.2 11.6l72.4-43.4c-2.8-6.1-4.4-12.7-4.4-19.8 0-26.5 21.5-48 48-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crown.js
// module id = 1250
// module chunks = 0